// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.kong-icon.kong-icon-spinner svg g{transform-box:fill-box;transform-origin:50% 50%;animation:spin 1.2s linear infinite}", ""]);
// Exports
module.exports = exports;
